(() => {
  const horizontalInfos = [
    ...Array.from(
      document.querySelectorAll<HTMLElement>("[data-horizontal-info]")
    ),
  ];

  [...horizontalInfos].forEach((horizontalInfo) => {
    const horizontalInfoBtn: HTMLButtonElement | null = horizontalInfo.querySelector(
      ".horizontal-info__toggle"
    );
    const horizontalInfoInner: HTMLButtonElement | null = horizontalInfo.querySelector(
      ".horizontal-info__inner"
    );

    if (horizontalInfoBtn && horizontalInfoInner) {
      if (window.innerWidth < 768) {
        horizontalInfoBtn.setAttribute("aria-expanded", "false");
        horizontalInfoInner.setAttribute("aria-hidden", "true");
      }

      const onToggleClick = () => {
        if (horizontalInfo.classList.contains("is-open")) {
          horizontalInfo.classList.remove("is-open");
          horizontalInfoBtn.setAttribute("aria-expanded", "false");
          horizontalInfoInner.setAttribute("aria-hidden", "true");
        } else {
          horizontalInfo.classList.add("is-open");
          horizontalInfoBtn.setAttribute("aria-expanded", "true");
          horizontalInfoInner.setAttribute("aria-hidden", "false");
        }
      };

      horizontalInfoBtn.addEventListener("click", onToggleClick);
    }
  });
})();

export {};
